import { render } from "./Confidentialite.vue?vue&type=template&id=6f762172&scoped=true"
import script from "./Confidentialite.vue?vue&type=script&lang=js"
export * from "./Confidentialite.vue?vue&type=script&lang=js"

import "./Confidentialite.vue?vue&type=style&index=0&id=6f762172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f762172"]])

export default __exports__